import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";

import Notification from "../models/notification.model";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { environment } from "../../environments/environment";
import { WhereList } from "../models/pagination";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "";
  contentRef: AngularFirestoreCollection<Notification>;

  constructor(private db: AngularFirestore, private userStore: UserService) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      this.userLogin = user;

      this.contentRef = this.db.collection(
        `/shops/${this.userLogin.shopId}/notifications`
      );

      this.dbPath = `/shops/${this.userLogin.shopId}/notifications`;
    });
  }

  getFirst(workingTaskId?: string): AngularFirestoreCollection<Notification> {
    if (workingTaskId && workingTaskId != "") {
      return this.db.collection(this.dbPath, (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("toUid", "==", this.userLogin.uid)
          .where("workingTaskId", "==", workingTaskId)
          .orderBy("createdOn", "desc")
          .limit(5)
      );
    } else {
      return this.db.collection(this.dbPath, (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("toUid", "==", this.userLogin.uid)
          .orderBy("createdOn", "desc")
          .limit(5)
      );
    }
  }

  getNotifications(wheres: WhereList[], limit?: number, cursor?: any): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true);

    for (var i = 0; i < wheres.length; i++) {
      ref = ref.where(wheres[i].fieldPath, "==", wheres[i].value);
    }

    ref = ref.orderBy("createdOn", "desc");
    ref = limit ? ref.limit(limit) : ref.limit(10);
    if (cursor) {
      ref = ref.startAfter(cursor);
    }

    return ref.get();
  }

  create(
    type: string,
    mode: string,
    refId: string,
    fromId: string,
    title: string,
    description: string,
    toUid: string,
    refUrl: string,
    workingTaskId: string
  ): any {
    let content: Notification = new Notification();
    content.type = type ? type : "";
    content.mode = mode ? mode : "";
    content.refId = refId ? refId : "";
    content.fromId = fromId ? fromId : "";
    content.fromTitle = title ? title : "";
    content.fromDescription = description ? description : "";
    content.fromUid = this.userLogin.uid;
    content.fromAuthor = this.userLogin;
    content.toUid = toUid ? toUid : "";
    content.refUrl = refUrl ? refUrl : "";
    content.workingTaskId = workingTaskId ? workingTaskId : "";

    content.shopId = this.userLogin.shopId;
    content.isReceived = false;
    content.isActive = true;
    content.isDeleted = false;
    content.createdOn = new Date();
    content.createdBy = this.userLogin.uid;
    content.updatedOn = new Date();
    content.updatedBy = this.userLogin.uid;
    content.author = this.userLogin;
    content.visibility = this.visibility;

    console.log("NotificationServices/create:", content);
    return this.contentRef.add({ ...content }).then((docRef) => {
      content.id = docRef.id;
      return content;
    });
  }

  receive(id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.contentRef.doc(id).update({
      isReceived: true,
      receiveOn: updatedOn,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }

  delete(id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    return this.contentRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }
}
